import React, { useState, useEffect } from 'react';

import Header from '../Header.js';
import QiMeasuresGraphsBox from '../boxes/QiMeasuresGraphsBox.js';
import QiTimesGraphsBox from '../boxes/QiTimesGraphsBox.js';
import QiFatigueGraphsBox from '../boxes/QiFatigueGraphsBox.js';
import QiGpsGraphsBox from '../boxes/QiGpsGraphsBox.js';
import BoxTabs from '../boxes/BoxTabs.js';
import Footer from '../Footer.js';

const QualityImprovementPage = ({ user }) => {
    
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 1600); // screen width cutoff
        };
    
        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
    
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Define tabs configuration
    const tabs = [
        {
            label: "Quality Measures",
            component: QiMeasuresGraphsBox,
            props: { user: user }
        },
        {
            label: "Times Inspector",
            component: QiTimesGraphsBox,
            props: { user: user }
        },
        {
            label: "Fatigue Analysis",
            component: QiFatigueGraphsBox,
            props: { user: user }
        },
        {
            label: "GPS Data",
            component: QiGpsGraphsBox,
            props: { user: user }
        }
    ];

    return (
        <div>
            <Header 
                user={user} 
                buttonsVisible={{
                    homeButton: true,
                    qiButton: false
                }}
                displayQiImage={true}
                pageTitle="Quality Improvement"
            />
            <div className='box-spacer'/>
            <BoxTabs 
                tabs={tabs}
                defaultTabIndex={0}
                isSmallScreen={isSmallScreen}
            />
            <Footer />
        </div>
    );
};

export default QualityImprovementPage;